module.exports = __webpack_public_path__ + "img/f7c46bd.png";